export default class GreaterThan {
  constructor() {
    'ngInject';

    this.require = 'ngModel';
    this.restrict = 'A';
  }

  link($scope, element, attrs, ctrl) {
    const compareTo = attrs.greaterThan;

    $scope.$watch(attrs.greaterThan, () => {
      ctrl.$validate();
    });

    ctrl.$validators.greaterThan = (modelValue) => {
      const watchVal = $scope.$eval(compareTo);

      if (modelValue === undefined || watchVal === undefined) {
        return true;
      }

      return modelValue > watchVal;
    };
  }

  static directiveFactory() {
    'ngInject';

    return new GreaterThan();
  }
}



// WEBPACK FOOTER //
// ./common/directives/validation/greater-than.js